import styled from "styled-components";

export const PhotoWrap = styled.div`
  width: 48px;
  height: 48px;
  flex-shrink: 0;
`;

export const Row = styled.button<{ $checked: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 13px 14px;
  border-radius: 14px;
  cursor: pointer;
  text-align: left;
  font-family: ${(p) => p.theme.tokens.font.family};
  background: ${(p) => (p.$checked ? "#F1FAF5" : p.theme.tokens.colors.surface)};
  border: 1.5px solid ${(p) => (p.$checked ? "#BCE9D3" : p.theme.tokens.colors.line)};
  transition: all 0.15s;
`;

export const Texts = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Name = styled.div`
  font-weight: 800;
  font-size: 14.5px;
  color: ${(p) => p.theme.tokens.colors.ink};
`;

export const Desc = styled.div`
  font-size: 11.5px;
  color: ${(p) => p.theme.tokens.colors.muted};
  margin-top: 2px;
`;

export const Price = styled.span<{ $checked: boolean }>`
  font-weight: 800;
  font-size: 13px;
  white-space: nowrap;
  color: ${(p) => (p.$checked ? p.theme.tokens.colors.teal : p.theme.tokens.colors.muted)};
`;

export const Check = styled.span<{ $checked: boolean }>`
  width: 23px;
  height: 23px;
  border-radius: 999px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${(p) => (p.$checked ? "none" : "2px solid #D5DEDA")};
  background: ${(p) => (p.$checked ? p.theme.tokens.gradients.accent : p.theme.tokens.colors.surface)};
`;
